import { PreparationBasic } from './preparation.model';

export class ProductBasic {

    private active: boolean;
    private additionalInfo: string;
    private category: string;
    private categoryCode: string;
    private description: string;
    private gtin: string;
    private image: string;
    private internalCode: string;
    private internalId: string;
    private measure: number;
    private measureUnit: string;
    private pricePVP: number;
    private pricePVPOffer: number;
    private taxAmount: number;
    private tradename: string;
    private preparations: PreparationBasic[];

    constructor(active?: boolean, internalId?: string, gtin?: string, internalCode?: string, description?: string, tradename?: string, image?: string, additionalInfo?: string, category?: string, categoryCode?: string, measure?: number, measureUnit?: string, pricePVP?: number, pricePVPOffer?: number, taxAmount?: number, preparations?: PreparationBasic[]) {
        this.active = active;
        this.additionalInfo = additionalInfo;
        this.category = category;
        this.categoryCode = categoryCode;
        this.description = description;
        this.gtin = gtin;
        this.image = image;
        this.internalCode = internalCode;
        this.internalId = internalId;
        this.measure = measure;
        this.measureUnit = measureUnit;
        this.pricePVP = pricePVP;
        this.pricePVPOffer = pricePVPOffer;
        this.taxAmount = taxAmount;
        this.tradename = tradename;
        this.preparations = preparations;
    }

    public get Active(): boolean {
        return this.active;
    }

    public set Active(active: boolean) {
        this.active = active;
    }

    public get AdditionalInfo(): string {
        return this.additionalInfo;
    }

    public set AdditionalInfo(additionalInfo: string) {
        this.additionalInfo = additionalInfo;
    }

    public get Category(): string {
        return this.category;
    }

    public set Category(category: string) {
        this.category = category;
    }

    public get CategoryCode(): string {
        return this.categoryCode;
    }

    public set CategoryCode(categoryCode: string) {
        this.categoryCode = categoryCode;
    }

    public get Description(): string {
        return this.description;
    }

    public set Description(description: string) {
        this.description = description;
    }

    public get Gtin(): string {
        return this.gtin;
    }

    public set Gtin(gtin: string) {
        this.gtin = gtin;
    }

    public get Image(): string {
        return this.image;
    }

    public set Image(image: string) {
        this.image = image;
    }

    public get InternalCode(): string {
        return this.internalCode;
    }

    public set InternalCode(internalCode: string) {
        this.internalCode = internalCode;
    }

    public get InternalId(): string {
        return this.internalId;
    }

    public set InternalId(internalId: string) {
        this.internalId = internalId;
    }

    public get Measure(): number {
        return this.measure;
    }

    public set Measure(measure: number) {
        this.measure = measure;
    }

    public get MeasureUnit(): string {
        return this.measureUnit;
    }

    public set MeasureUnit(measureUnit: string) {
        this.measureUnit = measureUnit;
    }

    public get Preparations(): PreparationBasic[] {
        return this.preparations;
    }

    public set Preparations(preparations: PreparationBasic[]) {
        this.preparations = preparations;
    }

    public get PricePVP(): number {
        return this.pricePVP;
    }

    public set PricePVP(pricePVP: number) {
        this.pricePVP = pricePVP;
    }

    public get PricePVPOffer(): number {
        return this.pricePVPOffer;
    }

    public set PricePVPOffer(pricePVPOffer: number) {
        this.pricePVPOffer = pricePVPOffer;
    }

    public get TaxAmount(): number {
        return this.taxAmount;
    }

    public set TaxAmount(taxAmount: number) {
        this.taxAmount = taxAmount;
    }

    public get Tradename(): string {
        return this.tradename;
    }

    public set Tradename(tradename: string) {
        this.tradename = tradename;
    }

}
